import { render } from "./ThankYouPage.vue?vue&type=template&id=26e6ccb9&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=26e6ccb9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e6ccb9"]])

export default __exports__